/* eslint-disable no-mixed-spaces-and-tabs */

import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'

/* global sfclient */

class LiveVisitors extends Component {

  constructor(props) {
    super(props)

    this.state = {
      liveVisitors: [],
      isLiveVisitorsFetched: false
    }
  }

  componentDidUpdate() {
    if (this.props.user.chatUserFetched && !this.state.isLiveVisitorsFetched) {
      this.getLiveVisitors()
    }
  }

  componentDidMount() {
    if (window) {
      if (!window.jmdashboard) {
        window.jmdashboard = []
      }
      window.jmdashboard["livevisitors"] = this
    }
    if (this.props.user.chatUserFetched && !this.state.isLiveVisitorsFetched) {
      this.getLiveVisitors()
    }

    // if (this.dockerWidth !== this.dockerRef.offsetWidth) {
    //     this.dockerWidth = this.dockerRef.offsetWidth
    // }
  }



	getLiveVisitors = () => {
	  if (!window.sfChat) {
	    setTimeout(() => {
	      this.getLiveVisitors()
	    }, 1000)
	    return
	  }
	  let self = this
	  sfclient.chat.getLiveVisitors()
	    .then(function (res) {
	      self.setState({
	        liveVisitors: res.data,
	        isLiveVisitorsFetched: true
	      })
	    })
	}

	addNewVisitor = (data) => {
	  let liveVisitors = this.state.liveVisitors
	  let visitorIndex = liveVisitors.findIndex((visitor) => {
	    return visitor.user_id === data.user_id
	  })
	  if (visitorIndex > -1) {
	    liveVisitors.splice(visitorIndex, 1)
	    liveVisitors.push(data)
	  } else {
	    liveVisitors.push(data)
	  }
	  this.setState({
	    liveVisitors: liveVisitors
	  })
	}

	render() {
	  return (
	    <div className="bodyContent">
	      <section className="content-header">
	        <h1 style={{ marginBottom: '5px', fontWeight: '600', display: 'inline-block' }}>Live Visitors</h1>
	      </section>
	      <section className="content">

	        < VisitorsTable liveVisitors={this.state.liveVisitors} />
	      </section>
	    </div>
	  )
	}
}

class VisitorsTable extends Component {

	greetUser = (data) => {
	  const body = {
	    user_id: data.user_id,
	    profile_type: data.profile_type,
	    message: "Hello I would like to assist you"
	  }

	  sfclient.chat.greetUser(body)
	    // eslint-disable-next-line no-unused-vars
	    .then((res) => {
	    })
	    // eslint-disable-next-line no-unused-vars
	    .catch((err) => {
	    })

	}

	render() {

	  const defaultSort = {
	    defaultSortName: 'user_id',
	    defaultSortOrder: 'desc'
	  }

	  const currentPage = (cell) => {
	    return (
	      <div>
	        <span title={cell.current_page}>{cell.current_page}</span>
	      </div>
	    )
	  }

	  const timeSpent = (cell) => {
	    return (
	      <div>
	        <span>{moment(new Date(cell.activity_on)).fromNow()}</span>
	      </div>
	    )
	  }

	  return (
	    <div>
	      <BootstrapTable
	        data={this.props.liveVisitors}
	        options={defaultSort}
	        hover={false}
	        search={true}
	        height={"auto"}
	        searchPlaceholder="Search"
	        headerStyle={{ border: '0px', background: 'lightgrey' }}
	        tableStyle={{ border: '0px', 'background': 'white' }}
	        bodyStyle={{ border: '0px', overflow: 'auto' }}
	      >
	        <TableHeaderColumn isKey dataField='user_id' dataSort={true} width="100px" >Visitor ID</TableHeaderColumn>
	        <TableHeaderColumn dataField='name' width="200px" export={false}>Name</TableHeaderColumn>
	        <TableHeaderColumn dataField='client_app_id' data width="100px">App Name</TableHeaderColumn>
	        <TableHeaderColumn dataField='activity' dataFormat={currentPage} width="300px">Current Page</TableHeaderColumn>
	        <TableHeaderColumn dataField='activity' dataSort={true} width="200px" dataFormat={timeSpent}>Using Current Page Since</TableHeaderColumn>
	        {/* <TableHeaderColumn dataField='travelled_paths' width="200px">Travelled Paths</TableHeaderColumn> */}
	        <TableHeaderColumn dataField='user_ip' width="200px">Geo Location</TableHeaderColumn>
	        <TableHeaderColumn dataField='browser_info' width="300px">Browser</TableHeaderColumn>
	        {/* <TableHeaderColumn dataField='since_last_meeting' width="200px">Since Last Meeting</TableHeaderColumn> */}
	        {/* <TableHeaderColumn dataField='meeting_histories' width="200px">Meeting Histories</TableHeaderColumn> */}
	      </BootstrapTable>
	    </div>
	  )
	}
}

export function live_visitors() {
  return window.jmdashboard["livevisitors"]
}

const mapStateToProps = (state) => {
  return {
    user: state.userReducer
  }
}

export default connect(mapStateToProps)(LiveVisitors)


// WEBPACK FOOTER //
// ./src/components/visitors/live_visitors.js